import { bemClasses } from "../../../general/js/modal";

export const modalConstants = {
    dataModal: 'data-modal',
    MODAL_BEM_CLASS_WIDE: `modal--${bemClasses.WIDE}`,
    MODAL_BEM_CLASS_DESKTOP_WIDE: `modal--${bemClasses.DEKSTOP_WIDE}`,
    MODAL_BEM_CLASS_MOBILE_FIXED: `modal--${bemClasses.MOBILE_FIXED}`,
    MODAL_BEM_CLASS_CLOSE_OUTSIDE: `modal--${bemClasses.CLOSE_OUTSIDE}`,
    MODAL_BEM_CLASS_TITLE: `modal--${bemClasses.TITLE}`,
    MODAL_BEM_CLASS_AUTO: `modal--${bemClasses.AUTO}`,
    MODAL_BEM_CLASS_SPLIT: `modal--${bemClasses.SPLIT}`
}